import React, { useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFlag } from "@fortawesome/free-solid-svg-icons";
import { ReportModal } from "components/shared/ReportModal/ReportModal";

export const FeedbackCTA = ({
  label = "Report an Issue or Give Feedback",
  defaultMessage,
  contextMessage,
  reportLocation,
  extraPayload,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <StyledButton onClick={() => setIsModalOpen(true)}>
        <FontAwesomeIcon icon={faFlag} />
        <span>{label}</span>
      </StyledButton>
      <ReportModal
        show={isModalOpen}
        onHide={() => setIsModalOpen(false)}
        defaultMessage={defaultMessage}
        contextMessage={contextMessage}
        reportLocation={reportLocation}
        extraPayload={extraPayload}
      />
    </>
  );
};

const StyledButton = styled.button`
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #002e19;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  text-decoration: none;
  padding: 8px 12px;
  border-radius: 8px;
  background: none;
  border: none;

  &:hover {
    color: #002e19;
    text-decoration: none;
    background-color: rgba(0, 46, 25, 0.08);
  }
`;
